"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPInput.css");
var PPIconLink_1 = require("../PPIconLink");
var PPInput = function (_props) {
    var error = _props.error, decoration = _props.decoration, functions = _props.functions, suggestions = _props.suggestions, props = __rest(_props, ["error", "decoration", "functions", "suggestions"]);
    var _a = (0, react_1.useState)([]), suggestionsList = _a[0], setSuggestionsList = _a[1];
    var _b = (0, react_1.useState)(0), suggestionsTop = _b[0], setSuggestionsTop = _b[1];
    var _c = (0, react_1.useState)(false), loadingSuggestions = _c[0], setLoadingSuggestions = _c[1];
    var onChange = function (event) {
        (!props.disabled && !props.readOnly) && props.onChange &&
            props.onChange(event);
    };
    var timer;
    var onInput = function (event) {
        setSuggestionsList([]);
        clearTimeout(timer);
        timer = setTimeout(function () { return loadSuggestions(event); }, 1000);
    };
    var loadSuggestions = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var s;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(suggestions && event.target.value.length > 0)) return [3 /*break*/, 2];
                    setLoadingSuggestions(true);
                    return [4 /*yield*/, suggestions(event.target.value)];
                case 1:
                    s = _a.sent();
                    setSuggestionsList(s);
                    setLoadingSuggestions(false);
                    _a.label = 2;
                case 2:
                    event.target.value.length === 0 &&
                        setSuggestionsList([]);
                    return [2 /*return*/];
            }
        });
    }); };
    var formatSuggestion = function (suggestion) {
        var val = props.value;
        var iniIndex = suggestion.toLowerCase().indexOf(val.toLowerCase());
        var sizeIndex = val.length;
        var p1 = suggestion.substring(0, iniIndex);
        var p2 = suggestion.substring(iniIndex, iniIndex + sizeIndex);
        var p3 = suggestion.substring(iniIndex + sizeIndex, suggestion.length);
        var newSug = "".concat(p1, "<b>").concat(p2, "</b>").concat(p3);
        return react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: newSug } });
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('scroll', function (event) {
            event.target.className !== 'suggestions' &&
                onScroll();
        }, true);
        return function () {
            window.removeEventListener("scroll", onScroll, true);
        };
    }, []);
    var onScroll = function () {
        setSuggestionsList([]);
    };
    return (react_1.default.createElement("div", { className: "pp-input".concat(props.disabled ? " disabled" : "").concat(props.readOnly ? " readonly" : ""), style: { width: props.width || undefined }, ref: function (ref) {
            if (ref) {
                try {
                    var _top = ref.getClientRects()[0].top + (props.title ? 60 : 40);
                    setSuggestionsTop(_top);
                }
                catch (error) { }
            }
        }, onMouseLeave: function () { return setSuggestionsList([]); } },
        props.title &&
            react_1.default.createElement("div", { className: "title" }, props.title),
        react_1.default.createElement("div", { className: "field".concat((!props.disabled && !props.readOnly) && props.required ? ' required' : '').concat((error === null || error === void 0 ? void 0 : error.show) ? ' error' : '') },
            decoration &&
                react_1.default.createElement("div", { className: "decoration" }, decoration),
            react_1.default.createElement("input", __assign({}, props, { className: "value", type: props.type, onInput: onInput })),
            react_1.default.createElement("div", { className: "icons" },
                !(props.required || props.readOnly || props.disabled) && props.value &&
                    react_1.default.createElement("i", { className: "ppi ppi-x", onClick: function () { return (!props.disabled || !props.readOnly) && onChange({ target: { name: props.name, value: "" } }); } }), functions === null || functions === void 0 ? void 0 :
                functions.map(function (f, i) {
                    return react_1.default.createElement(PPIconLink_1.PPIconLink, { key: i, tooltipPosition: "right", size: "small", icon: f.icon, tooltip: f.tooltip, onClick: f.onClick, disabled: f.disabled || props.disabled || props.readOnly });
                }))),
        suggestions && suggestionsList.length > 0 &&
            react_1.default.createElement("div", { className: "suggestions", style: { top: suggestionsTop } }, suggestionsList.map(function (s, i) {
                return react_1.default.createElement("div", { key: i, className: 'suggestion', onClick: function () {
                        setSuggestionsList([]);
                        onChange({ target: { value: s, name: props.name } });
                    } }, formatSuggestion(s));
            })),
        suggestions && loadingSuggestions &&
            react_1.default.createElement("div", { className: "loading", style: { top: suggestionsTop } }, "Carregando..."),
        (error === null || error === void 0 ? void 0 : error.show) && error.help !== undefined &&
            react_1.default.createElement("div", { className: "help" },
                react_1.default.createElement("i", { className: "ppi ppi-chevron-up-alt" }),
                react_1.default.createElement("div", { className: "main" },
                    react_1.default.createElement("div", { className: "content" }, error.help)))));
};
exports.default = PPInput;
